import { FetchPlaceUseCase } from '@/module/place/domain/usecase/fetch_place_usecase';
import { FetchPumpMotoUseCase } from '../domain/usecase/fetch_remote_control_usecase';
import { ChangeRemoteControlUseCase } from '../domain/usecase/change_remote_control_usecase';
import { PumpMotoPagination } from '../domain/model/pump_moto_pagination';
import { Place } from '@/module/place/domain/model/place';
import { DataOptions } from 'vuetify';
import { headers } from '../const/headers';
import { PumpMoto } from '../domain/model/pump_moto';
import { snackbar } from '@/core/controller/snackbar_controller';
import { PlacePagination } from '@/module/place/domain/model/place_pagination';
import { MarkPumpPagination } from '@/module/pumpMark/domain/model/markPump_pagination';
import { MarkPump } from '@/module/pumpMark/domain/model/markPump';
import { CompanyPagination } from '@/module/company/domain/model/company_pagination';
import { FetchCompanyUseCase } from '@/module/company/domain/usecase/fetch_company_usecase';
import { itemStatus, visibilityStatus } from '@/core/domain/model/pagination';
import { FetchLastEventForOwnerUseCase } from '@/module/event/domain/usecase/fetch_last_event_for_owner_usecase';
import { FetchEventsUseCase } from '@/module/event/domain/usecase/fetch_events_usecase';
import { Event, OWNER_TYPE } from '@/module/event/domain/model/event';
import { FetchPumpMotoLogUseCase } from '@/module/pump_moto_log/domain/usecase/fetch_pump_moto_log_usecase';
import { STATUS } from '@/module/pump_moto/domain/model/pump_moto';
import { HealthCheckUseCase } from '../domain/usecase/remote_control_health_check_usecase';

import * as XLSX from "xlsx";

import axios from 'axios'

class PumpMotoController {
  public context: any;
  public status: number = 0
  public dialog: boolean = false;
  public columns: Array<any> = headers
  public search: string = ""
  public searchPlace: string = ""
  public searchCompany: string = ""
  public flagOption: string = ""
  public loading: boolean = false
  public loadingLogs: boolean = false
  public groupBy: string = ""
  public menuGroup: boolean = false
  public dialogTracking: boolean = false
  public dialogPumpTracking: boolean = false
  public dialogRulerTrackingLevel: boolean = false
  public selectedPumpMoto: PumpMoto | null = null
  public selected: Array<MarkPump> = []
  public loadingBtnExcel : boolean = false
  public lastHealthCheck?: Event | null = null;
  public lastPlaceEvent?: Event | null = null
  public selectedMarkPump: MarkPump = {
    id: 0,
    accountID: 0,
    amperage: 0,
    capacitors: 0,
    createdDate: "",
    description: "",
    engines: 0,
    higherLevel: 0,
    hourMeter: 0,
    lowerLevel: 0,
    pumpID: 0,
    voltage: 0,
    power: 0
  }
  public selectedPlace: Place = {
    color: "",
    companyID: 0,
    companyName: "",
    id: 0,
    imagePath: "",
    latitude: "",
    longitude: "",
    name: ""
  }
  public visibilityStatus = visibilityStatus
  public itemStatus = itemStatus
  public pumpMotoPagination: PumpMotoPagination = {
    total: 0,
    items: []
  }
  public pumpMotoPaginationNoPlace: PumpMotoPagination = {
    total: 0,
    items: []
  }
  public trackingPagination: MarkPumpPagination = {
    total: 0,
    items: []
  }
  public placePagination: PlacePagination = {
    total: 0,
    items: []
  }
  public companyPagination: CompanyPagination = {
    total: 0,
    items: []
  }
  public options: DataOptions = {
    page: 1,
    itemsPerPage: 1000,
    groupBy: [],
    sortBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }
  public optionsPlace: DataOptions = {
    page: 1,
    itemsPerPage: 1000,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }
  public optionsTracking: DataOptions = {
    page: 1,
    itemsPerPage: 1000,
    groupBy: [],
    sortBy: ["createdDate"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: [true]
  }
  public optionsCompany: DataOptions = {
    page: 1,
    itemsPerPage: 1000,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  public pumpMoto: PumpMoto = {
    id: 0, placeID: 0, name: "", EngineID: 0, EngineName: "", CompanyID: 0, checkbox:false, isButtonDisabled: true, withPump: true ,isFavorite: false, remoteControl: false, energyMonitoring: false, inUseSet: false, Status: 0, CompanyName: "", placeName: ""
  }

  private fetchPlaceUseCase: FetchPlaceUseCase
  private fetchPumpMotoUseCase: FetchPumpMotoUseCase
  private changeRemoteControlUseCase: ChangeRemoteControlUseCase
  private fetchCompanyUseCase: FetchCompanyUseCase
  private fetchEventsUseCase: FetchEventsUseCase
  private fetchLastEventUseCase: FetchLastEventForOwnerUseCase
  private healthCheckUseCase: HealthCheckUseCase
  private fetchPumpMotoLogsUseCase: FetchPumpMotoLogUseCase

  constructor(
    context: any,
    fetchPlaceUseCase: FetchPlaceUseCase,
    fetchPumpMotoUseCase: FetchPumpMotoUseCase,
    changeRemoteControlUseCase: ChangeRemoteControlUseCase,
    fetchCompanyUseCase: FetchCompanyUseCase,
    fetchEventsUseCase: FetchEventsUseCase,
    fetchLastEventUseCase: FetchLastEventForOwnerUseCase,
    healthCheckUseCase: HealthCheckUseCase,
    fetchPumpMotoLogsUseCase: FetchPumpMotoLogUseCase
  ) {
    this.context = context
    
    this.fetchPlaceUseCase = fetchPlaceUseCase
    this.fetchPumpMotoUseCase = fetchPumpMotoUseCase
    this.changeRemoteControlUseCase = changeRemoteControlUseCase
    this.fetchCompanyUseCase = fetchCompanyUseCase
    this.fetchEventsUseCase = fetchEventsUseCase
    this.fetchLastEventUseCase = fetchLastEventUseCase
    this.healthCheckUseCase = healthCheckUseCase
    this.fetchPumpMotoLogsUseCase = fetchPumpMotoLogsUseCase
  }

  public healthCheck = async (): Promise<void> => {
    try {
      const responseStatus = await this.healthCheckUseCase(this.selectedPlace.id)

      if (responseStatus === 200) snackbar.show({ message: "Conexao OK", color: 'green', timeout: 2500 })
    } catch (e) {
      console.error(e)

      if (!axios.isAxiosError(e)) return

        switch (e.response?.status) {
          case 500:
            snackbar.show({ message: "Erro de conexao com a API", color: 'red', timeout: 2500 })
          break
          case 503:
            snackbar.show({ message: "Falha de conexao: servico mqtt indisponivel", color: 'red', timeout: 2500 })
          break
          case 504:
            snackbar.show({ message: "Falha de conexao: tempo de resposta do levante muito longo", color: 'red', timeout: 2500 })
          break
          default:
            snackbar.show({ message: "Erro de conexao", color: 'red', timeout: 2500 })
        }
    } finally {
      await this.fetchLastHealthCheck()
    }
  }

  public exportPlaceEvents = async (interval: { start: string, end: string }): Promise<void> => {
    try {
      const result = await this.fetchEventsUseCase({
        ownerType: OWNER_TYPE.REMOTE_CONTROL,
        ownerID: this.selectedPlace.id,
        startDate: interval.start,
        endDate: interval.end,
        page: 1,
        itemsPerPage: -1
      })

      if (!result || result.items.length !== result.total) throw new Error("exportPlaceEvents :: invalid result")

      const heading = [['ID', 'OWNER_TYPE', 'OWNER_ID', 'TYPE', 'DESCRIPTION', 'CRETED_DATE', 'UPDATED_DATE']];
      const wb = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, heading);

      XLSX.utils.sheet_add_json(ws, result.items, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws, `eventos :: levante ${this.selectedPlace.id}`);

      XLSX.writeFile(wb, `eventos_levante_${this.selectedPlace.id}.xlsx`);
    } catch (e: any) {
      snackbar.show({ message: "Erro ao buscar eventos", color: 'red' })
      console.error(e)
    }
  }

  public exportPlaceLogs = async (interval: { start: string, end: string }): Promise<void> => {
    try {
      const result = await this.fetchPumpMotoLogsUseCase({
        placeID: this.selectedPlace.id,
        startDate: interval.start,
        endDate: interval.end,
        page: 1,
        itemsPerPage: -1
      })

      if (!result || result.items.length !== result.total) throw new Error("exportPlaceLogs :: invalid result")

      const heading = [[
        'ID',
        'PLACE_ID',
        'WITH_PLACE',
        'RSSI',
        'STATUS',
        'REMOTE_PLACE',
        'WITH_PUMP',
        'TIME_STAMP',
        'CREATED_DATE',
        'UPDATED_DATE',
        'SYSTEM_STATUS'
      ]];
      const wb = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, heading);

      XLSX.utils.sheet_add_json(ws, result.items, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws, `logs :: levante ${this.selectedPlace.id}`);

      XLSX.writeFile(wb, `logs_levante_${this.selectedPlace.id}.xlsx`);
    } catch (e: any) {
      snackbar.show({ message: "Erro ao buscar log de acionamentos", color: 'red' })
      console.error(e)
    }
  }

  async paginate() {
    this.loading = true;
    try {
      this.placePagination = await this.fetchPlaceUseCase(this.options, this.search);
      this.pumpMotoPaginationNoPlace = await this.fetchPumpMotoUseCase(this.options, this.search, this.status);
      const selectedPlaceID = this.selectedPlace.id;
  
      const filteredItems = this.pumpMotoPaginationNoPlace.items.filter(
        (item) => item.placeID === selectedPlaceID
      );

      const sortedItems = filteredItems.sort((a, b) => a.id - b.id);
  
      this.pumpMotoPagination = {
        total: sortedItems.length,
        items: sortedItems,
      };
      
    } catch (error: any) {
      snackbar.show({ message: error.toString() });
    } finally {
      this.loading = false;
    }
  }
  

  async paginatePlace() {
    if (this.searchPlace != null) {
      try {
        this.placePagination = await this.fetchPlaceUseCase(this.optionsPlace, this.searchPlace)
      } catch (error: any) {
        snackbar.show({ message: error.toString() })
      }
    }
  }

  async changePlace(data: Place) {
    this.selectedPlace = data
    this.paginate()
  }

  async lastEventFor(pumpMoto: PumpMoto) {
    try {
      // TODO: move the event type to the event model!
      const lastEvent = await this.fetchLastEventUseCase(OWNER_TYPE.PUMP_MOTO, pumpMoto.id, "PumpMotoStateChange")

      return lastEvent
    } catch (error: any) {
      console.error("Error on fetch last event :: ", error)
      snackbar.show({ message: error.toString() })

      return null
    }
  }

  async fetchLastPlaceEvent() {
    if (!this.selectedPlace?.id) return

    try {
      this.lastPlaceEvent = await this.fetchLastEventUseCase(OWNER_TYPE.REMOTE_CONTROL, this.selectedPlace.id, "RemoteControlChangeEvent")
    } catch (error: any) {
      console.error(error.toString())
      snackbar.show({ message: `Erro ao buscar eventos para o levante` })
    }
  }

  async fetchLastHealthCheck(): Promise<void> {
    if (!this.selectedPlace?.id) return

    try {
      const result = await this.fetchLastEventUseCase(OWNER_TYPE.REMOTE_CONTROL, this.selectedPlace.id, "RemoteControlHealthCheckEvent")

      this.lastHealthCheck = result
    } catch (error: any) {
      snackbar.show({ message: error.toString() })
    }
  }

  async paginateCompany() {
    if (this.searchCompany != null) {
      try {
        this.companyPagination = await this.fetchCompanyUseCase(this.optionsCompany, this.searchCompany)
      } catch (error: any) {
        snackbar.show({ message: error.toString() })
      }
    }
  }

  watchOptions() {
    this.paginate()
  }

  watchSearch() {
    this.paginate()
  }
  watchOptionsPlace() {
    this.paginatePlace()
  }

  watchSearchPlace() {
    this.paginatePlace()
  }

  watchSearchCompany() {
    this.paginateCompany()
  }

  watchOptionsCompany() {
    this.paginateCompany()
  }

  async handleChange(item: PumpMoto): Promise<boolean> {
    const statusArray = this.pumpMotoPagination.items.map(({ Status: status }) => status);
    const clickedItemIndex = this.pumpMotoPagination.items.findIndex(({ id }) => id === item.id);

    statusArray[clickedItemIndex] = statusArray[clickedItemIndex] === STATUS.ACTIVE ? STATUS.INACTIVE : STATUS.ACTIVE;

    try {
      await this.changeRemoteControlUseCase({
        id: item.id,
        status: statusArray,
        companyID: item.CompanyID,
        placeID: item.placeID,
      });

      await this.fetchLastPlaceEvent()

      return true
    } catch (e) {
      console.error(e)
      snackbar.show({ message: 'Ops, ocorreu um erro ao atualizar esse conjunto' })

      return false
    }
  }

  async handleMultiChange(): Promise<boolean> {
    const statusArray: number[] = [];
  
    this.pumpMotoPagination.items.forEach((item) => {
      // this will be set when user clicks on card checkbox
      const newStatus = item.checkbox
        ? (item.Status === STATUS.ACTIVE ? STATUS.INACTIVE : STATUS.ACTIVE)
        : item.Status;

      statusArray.push(newStatus);
    });
  
    if (statusArray.length === 0) return true;
  
    try {
      const changePromise = this.changeRemoteControlUseCase({
        status: statusArray,
        companyID: this.selectedPlace.companyID,
        placeID: this.selectedPlace.id,
      });

      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error("Sem resposta do equipamento. Tente novamente!"));
        }, 25000);
      });

      await Promise.race([changePromise, timeoutPromise]);

      await new Promise(resolve => setTimeout(resolve, 3000));

      await this.fetchLastPlaceEvent()

      return true
    } catch (error: any) {
      console.error('controller :: multi change :: ', error)
      snackbar.show({ message: 'Ops, ocorreu um erro ao atualizar os conjuntos' })
      return false
    }
  }
}

export default PumpMotoController
